export default "__VITE_ASSET__7dfd8cde__"